import { useIsFetching } from '@tanstack/react-query';
import { queryFilter as assetListQueryFilter } from '@unistocks/features/dashboard/components/dashboard-data/asset-list/query-filter';
import { queryFilter as calendarQueryFilter } from '@unistocks/features/dashboard/components/dashboard-data/date/query-filter';
import { queryFilter as eventViewValueQueryKey } from '@unistocks/features/dashboard/components/dashboard-data/event-view/query-filter';
import { queryFilter as netSavingsQueryFilter } from '@unistocks/features/dashboard/components/dashboard-data/net-savings/query-filter';
import { queryFilter as portfolioHistoryQueryFilter } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-history/query-filter';
import { queryFilter as portfolioOverviewQueryFilter } from '@unistocks/features/dashboard/components/dashboard-data/portfolio-overview/query-filter';
import { queryFilter as savingsGoalQueryFilter } from '@unistocks/features/dashboard/components/dashboard-data/savings-goal/query-filter';
import { DashboardItemDto, DashboardItemType } from '@unistocks/proxy/axios-client';

export const QUERY_FILTERS = {
  [DashboardItemType.AssetList]: assetListQueryFilter,
  [DashboardItemType.Date]: calendarQueryFilter,
  [DashboardItemType.EventView]: eventViewValueQueryKey,
  [DashboardItemType.NetSavings]: netSavingsQueryFilter,
  [DashboardItemType.PortfolioHistory]: portfolioHistoryQueryFilter,
  [DashboardItemType.PortfolioOverview]: portfolioOverviewQueryFilter,
  [DashboardItemType.SavingsGoal]: savingsGoalQueryFilter
};

/**
 * Returns whether the dashboard item is currently fetching data.
 * @param item
 */
export const useIsDashboardItemFetching = (item: DashboardItemDto) => {
  const queryFilter = QUERY_FILTERS[item.type](item);
  if (queryFilter) queryFilter.exact = true;

  return useIsFetching(queryFilter ?? { predicate: () => false });
};
